<template>
<div>


<h2 class="goth" ref="gramtitel">Ackusativ- och dativobjekt</h2>

<div class="grammatikparagrafbredd leftorient">
<h4 class="grammatikparagrafbredd leftorient">Satsanalys</h4><br>

<p class="grammatikparagrafbredd leftorient">Försök att ta ut satsdelarna i följande mening:</p>
<br>
<div class="grammatikparagrafbredd leftorient storre"><div class="bla inlajn">Mamma</div> ger <div class="rod inlajn"> mig
</div><div class="gron inlajn">en present</div>.</div><br>

<div class="grammatikparagrafbredd leftorient inlajn"><div class="bla inlajn">(Mutter</div> gibt <div class="rod inlajn"> mir
</div><div class="gron inlajn">ein Geschenk)</div>.</div><br><br>




<div class="grammatikparagrafbredd leftorient ruta">

    <p><b>Predikatet</b> beskriver själva handlingen i en sats; vad någon gör eller vad som händer.
        Det är <u>alltid ett verb</u> (eller ibland flera, om hjälpverb finns med).
    <p> I exemplet: <i> ger</i></p>

<br>
<div class="bla inlajn"> <b>Subjektet</b></div> är den eller det som utför själva handlingen - den aktiva.
    Det står alltid i nominativ, grundform.<br>

<br>I exemplet: <i><div class="bla inlajn"> Mamma</div></i><br>
<br><br>

<div class="gron inlajn"> <b>Ackusativobjektet</b></div> kan man få reda på genom frågan:
    <i>Vad</i> + <b>predikat</b> + <div class="bla inlajn"><b>subjekt</b></div>.

 <br>Alltså i exemplet: <i>"Vad <b>ger</b> <div class="bla inlajn"> Mamma?"</div></i>  - Svar: <i><div class="gron inlajn"> en present</div></i> <br>
<br>


<br><div class="rod inlajn"> <b>Dativobjektet</b></div> kan man få reda på genom frågan:<br>
    <i>[åt / till / för] vem</i> + <b>predikat</b> + <div class="bla inlajn"><b>subjekt</b></div> +
    <div class="gron inlajn"><b>ackusativobjekt</b></div>.<br>

<br> Alltså i exemplet: <i>"(till) vem <b>ger</b> <div class="bla inlajn"> Mamma</div> <div class="gron inlajn"> en present"</div></i>  - Svar: <i><div class="rod inlajn"> mig</div></i> <br>
<br>


</div>
 <br>



<div class="grammatikparagrafbredd leftorient">
    <p>Observera att på svenska kan man uttrycka samma mening på två sätt:</p>
<div class="ruta x-pad">
    <p>     <i>Mamma ger mig en present.</i></p><p> och</p><p><i>Mamma ger en present till mig</i>.</p>
</div>
    <p>Den andra meningen använder ett <i>prepositionsobjekt</i> med prepositionen <i>till</i> istället för dativobjekt.
         På tyska använd emellertid ENDAST dativobjekt i sådana meningar, alltså: </p>

<div class="ruta">
    <p>     <i>Mutter gibt mir ein Geschenk.</i> </p>

    <p>Man kan <b>inte</b> säga </p><p><i><strike>Mutter gibt ein Geschenk zu mir.</strike></i></p>

</div>
        <p> <b>Dativobjektet</b> kommer i regel alltid <b>före ackusativobjektet</b> i tyskan!</p><br>



</div>
<br>
<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i nominativ, ackusativ och dativ</h4><br>


    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit bgbla">der</td>
            <td class="vit bgbla">das</td>
            <td class="vit bgbla">die</td>
            <td class="vit bgbla">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="vit bggron"><b>den</b></td>
            <td class="vit bggron">das</td>
            <td class="vit bggron">die</td>
            <td class="vit bggron">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="vit bgrod"><b>dem</b></td>
            <td class="vit bgrod"><b>dem</b></td>
            <td class="vit bgrod"><b>der</b></td>
            <td class="vit bgrod"><b>den ..n</b> </td>
        </tr>





    </table>
<br><br><div class="grammatikparagrafbredd leftorient">Ord som <i>dieser</i> böjs på samma sätt som bestämd artikel:
    <br><br>

<div class="ruta x-pad">
    <div class="bla inlajn"><i>Dies<b>er</b> Mann</i></div> <i> gab</i> <div class="rod inlajn"><i> dies<b>em</b> Kind</i></div>



<div class="gron inlajn"><i> dies<b>es</b> Geschenk. </i></div><br><i>Denna man gav detta barn denna present.</i> </div>

</div>
<br>

<br>
<br>

    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i nominativ, ackusativ och dativ</h4><br>


        <table class="">

            <tr class="leftorient">
                <td></td>
                <td class="ljusgra">mask.</td>
                <td class="ljusgra">neutr.</td>
                <td class="ljusgra">fem.</td>
                <td class="ljusgra">plur.</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">nom.</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">eine</td>
                <td class="vit bgbla">(keine)</td>
            </tr>

            <tr class="leftorient">
                <td class="ljusgra">ack.</td>
                <td class="vit bggron"><b>einen</b></td>
                <td class="vit bggron">ein</td>
                <td class="vit bggron">eine</td>
                <td class="vit bggron">(keine)</td>
            </tr>
            <tr class="leftorient">
                <td class="ljusgra">dat.</td>
                <td class="vit bgrod"><b>einem</b></td>
                <td class="vit bgrod"><b>einem</b></td>
                <td class="vit bgrod"><b>einer</b></td>
                <td class="vit bgrod"><b>(keinen) + n</b></td>
            </tr>



        </table>
<br>
<div class="grammatikparagrafbredd leftorient">Tänk på att ord som <i>kein</i> och <b>possessiva pronomen</b> som <i>mein, dein, sein, ihr</i> o.s.v. böjs på
    samma sätt som obestämd artikel:</div><br>


<div class="ruta x-pad">
    <div class="grammatikparagrafbredd leftorient"><div class="bla inlajn"><i>Sie </i></div> <i>schreibt </i> <div class="rod inlajn"><i>ihr<b>er </b> Schwester </i></div> <div class="gron inlajn"><i>ein<b>en</b> Brief</i></div>
    <br><i>Hon skriver ett brev till sin syster.</i></div>
<br>
<div class="grammatikparagrafbredd leftorient"><div class="bla inlajn"><i>Ich </i></div> <i>zeige </i> <div class="rod inlajn"><i>mein<b>em</b> Bruder</i></div> <div class="gron inlajn"><i> mein<b>en</b> Garten</i></div>
<br><i>Jag visar min bror min trädgård.</i></div>
</div>

<br>

<br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i nominativ, ackusativ och dativ</h4><br>
<table class="">

    <tr class="leftorient">
        <td class="ljusgra">svenska</td>
        <td class="ljusgra">nominativ</td>
        <td class="ljusgra">ackusativ</td>
        <td class="ljusgra">dativ</td>
    </tr>
<tr></tr>
    <tr class="leftorient">
        <td class="ljusgra">jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bggron"><b>mich</b></td>
                <td class="vit bgrod"><b>mir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bggron"><b>dich</b></td>
                <td class="vit bgrod"><b>dir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bggron"><b>ihn</b><br>es<br>sie</td>
                <td class="vit bgrod"><b>ihm</b> <br> <b>ihm</b> <br> <b>ihr</b></td>
    </tr>
<tr></tr>
    <tr class="leftorient">
        <td class="ljusgra">vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bggron"><b>uns</b></td>
                <td class="vit bgrod"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bggron"><b>euch</b></td>
                <td class="vit bgrod"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bggron">sie<br>Sie</td>
                <td class="vit bgrod"><b>ihnen<br>Ihnen</b></td>
    </tr>




</table>

<br>
<br>
<div class="mindre">(Ackusativ- och dativform används även efter olika prepositioner.
    T.ex. alltid ackusativ efter <i>durch, für, gegen, ohne, um, </i>. Alltid dativ efter
    <i> aus, ausser, bei, gegenüber, mit nach seit von, zu</i>.
    Dativ eller ackusativ beroende på sammanhang efter
    <i>an, auf, hinter, in, neben, über, unter, vor, zwischen</i>.
    I dessa fall pratar man emellertid om <b>prepositionsobjekt</b> i ackusativ eller
    dativ och det skall inte förväxlas med <b>ackusativobjekt</b> och <b>dativobjekt</b> som beskrivs här.)</div>

</div>
<br><br><br>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "ackusativobjekt ackusativ dativobjekt dativ"
            }
        ]
    }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
